// modules/Buyer.js
import React from 'react'
import NavLink from './NavLink'
import SellerHome from "./SellerHome"

export default React.createClass({
  render() {
    return (
      <div>


      {this.props.children || <SellerHome/>}
      </div>
    )
  }
})


// WEBPACK FOOTER //
// ./src/Seller.js